import { render, staticRenderFns } from "./dimension-form-6.vue?vue&type=template&id=53b46109&scoped=true&"
import script from "./dimension-form-6.vue?vue&type=script&lang=ts&"
export * from "./dimension-form-6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b46109",
  null
  
)

export default component.exports